import { integration } from "./integration.js";

export default integration;
